<template>
  <SectionLayout :section-title="sectionTitle" section-key="recentPages" :loading="loadingDashboard">
    <template #default>
      <div class="gem-page-list" v-if="pagesList.length">
        <RecentPageItem v-for="(page, index) in pagesList" :key="page.id + '_' + index" :page="page" :loadingDashboard="loadingDashboard"/>
      </div>
      <div v-else class="d-flex flex-column align-items-center">
        <img :src="emptySrc" class="mt-3"/>
        <p class="mb-2 mt-3 paragraph-14-regular">
          <!-- It's empty here... Fill it up by creating your first page! -->
          <span class="text-dark-subtext2">{{ emptyDesc + "&nbsp;" }}</span>
          <router-link class="text-primary-300" :to="{ name: 'LandingPagesTemplate' }">{{ createLandingPage }}</router-link>
        </p>
      </div>
    </template>
  </SectionLayout>
</template>

<script>
import SectionLayout from "./SectionLayout.vue";
import { mapGetters, mapState } from "vuex";
import RecentPageItem from "./RecentPageItem.vue";

export default {
  name: "RecentPage",
  components: {
    SectionLayout,
    RecentPageItem,
  },
  data: () => ({
    emptySrc: require("@/core/assets/new-dashboard/recent-page-empty.svg")
  }),
  computed: {
    ...mapGetters("account", {
      language: "displayLanguage"
    }),
    ...mapState("account", {
      permissions: "permissions"
    }),
    ...mapGetters("dashboard", {
      recentPages: "recentPages",
      loadingDashboard: "loading"
    }),
    sectionTitle() {
      return this.$t("dashboard.recentPages");
    },
    emptyDesc() {
      return this.$t("dashboard.emptyRecentPagesDesc");
    },
    createLandingPage() {
      return this.$t("dashboard.emptyRecentPagesCreateLandingPage");
    },
    pagesList() {
      if (this.loadingDashboard) {
        return [false, false, false, false];
      }
      let pages = this.recentPages;
      if (pages.length > 5) {
        pages = pages.sort((a,b) => {
          return Date.parse(a.updatedAt) > Date.parse(b.updatedAt) ? -1 : 1
        })
        return pages.slice(0, 5);
      }
      return pages;
    }
  },
};
</script>

<style lang="scss">
.recent-pages {
  &__item {
    margin-top: 2px;
    border: solid 1px #D6D6D6;

    &.running-campaign {
      background-color: $light2;
    }

    &.default-page {
      &::before {
        @include trans-all;
        content: "";
        width: 4px;
        height: 80px;
        position: absolute;
        background: $mono3;
        border-radius: 3px 0 0 3px;
        z-index: 1;
      }
    }
    
    &:first-child {
      margin: 0
    }

    &:hover {
      border: 1px solid $dark10;
    }
  }

  &__row {
    height: 80px;
  }

  &__img {
    height: 80px;
    width: 144px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 3px;
    }
  }

  &__title {
    max-width: 195px;
    position: relative;

    .content {
      max-width: 278px;
      // @include ellipsis;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden !important;
      text-overflow: ellipsis;
      cursor: pointer;

      @media (max-width: 1170px) {
        max-width: 195px;
      }

      &.running-campaign {
        color: $textLightModeDisabled;
        cursor: pointer;
      }
    }
  }

  &__campaign {
    max-width: 195px;
    position: relative;
    &-desc {
      max-width: 100%;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden !important;
      text-overflow: ellipsis;
      cursor: pointer;
      @media (max-width: 1170px) {
        max-width: 100px;
      }
    }
    &-link {
      cursor: pointer;
      color: $cPrimary;
    }
  }

  &__gem-ai {
    &_text {
      margin-right: 3px;
      @media (max-width: 1200px) {
        display: none !important;
      }
    }
  }

  &__seperator {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    margin: 0px 8.5px;
    background-color: #676767;
    @media (max-width: 1170px) {
      display: none !important;
      &_gem-ai {
        display: block !important;
      }
    }
  }

  &__status {
    height: 16px;
    border-radius: 3px;
    padding: 0px 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    &-text {
      line-height: 14px !important;
    }
    &.default {
      background-color: $primaryBlue100;
      color: $primaryBlue350;
    }
    &.draft {
      background-color: $textDarkModeHigh;
      color: $textLightModeHigh;
    }
    &.need-publish, &.campaign {
      background-color: $accentAmber100;
      color: $accentAmber500;
    }
    &.published {
      background-color: $accentGreen100;
      color: $accentGreen500;
    }
    &.schedule {
      background-color: $accentGreen100;
      color: $accentGreen500;
      cursor: pointer;
      position: relative;
    }
  }

  &__schedule-publish, &__publish, &__modified {
    @media (max-width: 1170px) {
      display: none !important;
    }
  }

  &__action {
    border: none !important;
    &-view-live {
      @include trans-all;
      width: 40px;
      height: 40px;
      border-radius: 3px;
      &:not(.disabled) {
        cursor: pointer;
        &:hover{
          background-color: $textDarkModeHigh;
        }
      }
    }
  }

  &__loading {
    &-head {
      height: 16px;
    }

    &-action {
      height: 40px;
      width: 40px;
    }

    &-short {
      width: 120px;
      height: 16px;
    }

    &-long {
      width: 206px;
      height: 16px;
    }
  }
}

.tool-tip {
  padding: 8px;
  min-height: 30px;
  border-radius: 3px;
  background-color: $dark6;
  position: absolute;
  bottom: 150%;
  max-width: 550px;
  width: max-content;
  left: 0;
  line-height: 150% !important;
  z-index: 2;
  span {
    line-height: 150% !important;
  }
  @media (max-width: 1520px) {
    max-width: 400px;
  }
  @media (max-width: 1320px) {
    max-width: 300px;
  }
  @media (max-width: 1136px) {
    max-width: 200px;
  }
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 20%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: $dark6 transparent transparent transparent;
  }
  &-campaign {
    width: 300px;
    height: 50px;
    font-size: 11px;
    margin-left: auto;
    margin-right: auto;
    left: 50%;
    transform: translateX(-50%);

    &-desc {
      width: 168px;
    }

    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: $dark6 transparent transparent transparent;
    }
    &-value {
      line-height: 150% !important;
    }
  }
  &-value {
    color: $light1;
    font-size: 11px;
    line-height: 14px;
  }
} 
</style>
